import { FormEditorDialogView } from './FormEditorDialogView';
import type { FormEditorDialogProps } from './types';
import { useFormEditorDialog } from './useFormEditorDialog';

export type {
  ConditionalLogicOption,
  FieldTypeConditionMetadata,
  FieldTypeOption,
  FormEditorDialogLang,
  FormEditorDialogProps,
  FormEditorFieldData,
  FormEditorInitialData,
  FormEditorOutput,
  FormEditorPreviewData,
  FormEditorSectionData,
  FormPreviewHandle,
} from './types';

const FormEditorDialog = (props: FormEditorDialogProps) => (
  <FormEditorDialogView {...useFormEditorDialog(props)} />
);

export { FormEditorDialog };
